import React from "react";
import { PreviewLayout } from ".";
import { QRProps } from "@/contexts/QREditorContext/types";
import { NextImage } from "../NextImage";

export default function PreviewUrlStatic(props: QRProps<"url-static">) {
  const { qrUrlLink } = props.data || {};
  const t = props.previewTranslations["url_static"];

  const conditionalPreviewRender = () => {
    if (props?.preview)
      return (
        <>
          <div className="browser-url qr-url">{qrUrlLink ? qrUrlLink : "www.mywebsite.com"}</div>
          <NextImage
            src="/images/phone-previews/defaultPreview/preview_URL.png"
            width={241}
            height={512}
            alt="url preview"
            loading="lazy"
            className="default-preview default-preview-url"
          />
          <p className="default-preview-url-text">
            {t?.preview_url_title_1} <br /> {t?.preview_url_title_2}
          </p>
        </>
      );
    else window.location.href = qrUrlLink;
  };

  return (
    <PreviewLayout
      page="url-static"
      dataQA="preview-url-static-container"
      includeBrowser
    >
      {conditionalPreviewRender()}
    </PreviewLayout>
  );
}
